import script from "./Login.vue?vue&type=script&lang=js&setup=true"
export * from "./Login.vue?vue&type=script&lang=js&setup=true"

import "./Login.vue?vue&type=style&index=0&id=d85a6daa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d85a6daa"]])

export default __exports__